module.exports = {
	HOTEL_DETAILS: 'hotelDetail',
	RESULTS_DESTINATION: 'resultsDestination',
	DESTINATIONS_TREE: 'destinationsTree'
};



// WEBPACK FOOTER //
// ./src/globals/widgetTypes.js